(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["printmivo-product-reels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('printmivo-product-reels')) {
    customElements.define('printmivo-product-reels', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-reel-dialog]')
        this.stage = this.querySelector('[data-reel-stage]')
        this.slides = Array.from(this.querySelectorAll('[data-reel-slide]'))
        this.fullscreenVideos = Array.from(this.querySelectorAll('[data-reel-fullscreen-video]'))
        this.previewVideos = Array.from(this.querySelectorAll('[data-reel-preview]'))
        this.count = this.querySelector('[data-reel-count]')
        this.soundButton = this.querySelector('[data-reel-sound]')
        this.activeIndex = 0
        this.wheelLocked = false
        this.touchStartY = 0
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
        this.previewObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting || this.motionQuery.matches) return
            const video = entry.target
            if (!video.src) {
              video.src = video.dataset.src
              video.load()
            }
            video.play().then(() => video.classList.add('is-playing')).catch(() => {})
          })
        }, { rootMargin: '120px 0px' })
        this.previewVideos.forEach(video => this.previewObserver.observe(video))
        this.querySelectorAll('[data-reel-open]').forEach(button => button.addEventListener('click', () => this.open(Number(button.dataset.reelOpen))))
        this.querySelector('[data-reel-close]')?.addEventListener('click', () => this.dialog?.close())
        this.soundButton?.addEventListener('click', () => this.setMuted(!this.muted))
        this.dialog?.addEventListener('close', () => this.close())
        this.stage?.addEventListener('pointerdown', event => { this.touchStartY = event.clientY })
        this.stage?.addEventListener('pointerup', event => {
          const distance = event.clientY - this.touchStartY
          if (Math.abs(distance) < 48) return
          this.show(this.activeIndex + (distance < 0 ? 1 : -1))
        })
        this.stage?.addEventListener('wheel', event => {
          if (this.wheelLocked || Math.abs(event.deltaY) < 20) return
          event.preventDefault()
          this.wheelLocked = true
          this.show(this.activeIndex + (event.deltaY > 0 ? 1 : -1))
          window.setTimeout(() => { this.wheelLocked = false }, 420)
        }, { passive: false })
        this.onKeydown = event => {
          if (!this.dialog?.open) return
          if (event.key === 'Escape') this.dialog.close()
          if (event.key === 'ArrowDown' || event.key === 'PageDown') this.show(this.activeIndex + 1)
          if (event.key === 'ArrowUp' || event.key === 'PageUp') this.show(this.activeIndex - 1)
        }
        document.addEventListener('keydown', this.onKeydown)
      }

      open(index) {
        this.opener = document.activeElement
        this.setMuted(false)
        this.show(index, true)
        if (!this.dialog.open) this.dialog.showModal()
        this.querySelector('[data-reel-close]')?.focus()
      }

      setMuted(muted) {
        this.muted = muted
        this.fullscreenVideos.forEach(video => {
          video.defaultMuted = muted
          video.muted = muted
          if (muted) video.setAttribute('muted', '')
          else video.removeAttribute('muted')
        })
        if (this.soundButton) {
          this.soundButton.dataset.muted = String(muted)
          this.soundButton.setAttribute('aria-pressed', String(muted))
          this.soundButton.setAttribute('aria-label', muted ? this.soundButton.dataset.mutedLabel : this.soundButton.dataset.unmutedLabel)
        }
      }

      show(index, immediate = false) {
        const total = this.slides.length
        if (!total) return
        this.activeIndex = (index + total) % total
        this.slides.forEach((slide, slideIndex) => {
          let distance = slideIndex - this.activeIndex
          if (distance > total / 2) distance -= total
          if (distance < -total / 2) distance += total
          slide.style.transitionDuration = immediate ? '0ms' : ''
          slide.style.transform = `translateY(${distance * 100}%)`
          slide.style.opacity = distance === 0 ? '1' : '0'
          slide.setAttribute('aria-hidden', distance === 0 ? 'false' : 'true')
        })
        this.fullscreenVideos.forEach((video, videoIndex) => {
          if (videoIndex !== this.activeIndex) return video.pause()
          if (!video.src) {
            video.src = video.dataset.src
            video.load()
          }
          video.muted = this.muted
          if (!this.motionQuery.matches) video.play().catch(() => {})
        })
        if (immediate) requestAnimationFrame(() => this.slides.forEach(slide => { slide.style.transitionDuration = '' }))
        if (this.count) this.count.textContent = `${this.activeIndex + 1} / ${total}`
      }

      close() {
        this.fullscreenVideos.forEach(video => video.pause())
        this.opener?.focus?.()
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown)
        this.previewObserver?.disconnect()
      }
    })
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["printmivo-search-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('printmivo-search-controller')) {
    class PrintmivoSearchController extends HTMLElement {}
    customElements.define('printmivo-search-controller', PrintmivoSearchController)
  }

  ;(() => {
    const drawer = document.querySelector('[data-pm-search-drawer]')
    if (!drawer || drawer.dataset.initialized === 'true') return
    drawer.dataset.initialized = 'true'

    const input = drawer.querySelector('[data-pm-search-input]')
    const close = drawer.querySelector('[data-pm-search-close]')
    const clear = drawer.querySelector('[data-pm-search-clear]')
    const defaultContent = drawer.querySelector('[data-pm-search-default]')
    const results = drawer.querySelector('[data-pm-search-results]')
    const status = drawer.querySelector('[data-pm-search-status]')
    const searchPath = drawer.querySelector('[data-pm-search-form]')?.getAttribute('action') || '/search'
    let requestController
    let requestTimer
    let closeTimer
    let activeTrigger
    let scrollPosition = 0

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    const isMobile = window.matchMedia('(max-width: 600px)')
    const isDrawerOpen = () => !drawer.hidden && drawer.getAttribute('aria-hidden') === 'false'

    const lockPage = () => {
      scrollPosition = window.scrollY
      document.body.style.position = 'fixed'
      document.body.style.top = `-${scrollPosition}px`
      document.body.style.left = '0'
      document.body.style.right = '0'
      document.body.style.width = '100%'
    }

    const unlockPage = () => {
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.left = ''
      document.body.style.right = ''
      document.body.style.width = ''
      window.scrollTo(0, scrollPosition)
    }

    const openDrawer = event => {
      event?.preventDefault()
      if (isDrawerOpen()) return
      activeTrigger = event?.target?.closest?.('a') || document.activeElement
      window.clearTimeout(closeTimer)
      lockPage()
      drawer.classList.remove('is-visible', 'is-closing')
      drawer.hidden = false
      drawer.setAttribute('aria-hidden', 'false')
      drawer.getBoundingClientRect()
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => drawer.classList.add('is-visible'))
      })
      if (!isMobile.matches) window.setTimeout(() => input?.focus(), prefersReducedMotion.matches ? 0 : 620)
    }

    const closeDrawer = () => {
      if (!isDrawerOpen() || drawer.classList.contains('is-closing')) return
      requestController?.abort()
      window.clearTimeout(requestTimer)
      drawer.classList.add('is-closing')
      drawer.classList.remove('is-visible')

      const finishClose = () => {
        window.clearTimeout(closeTimer)
        drawer.hidden = true
        drawer.setAttribute('aria-hidden', 'true')
        drawer.classList.remove('is-closing')
        unlockPage()
        activeTrigger?.focus?.({ preventScroll: true })
      }

      if (prefersReducedMotion.matches) {
        finishClose()
      } else {
        closeTimer = window.setTimeout(finishClose, 820)
      }
    }

    const showDefault = () => {
      defaultContent.hidden = false
      results.hidden = true
      results.innerHTML = ''
      status.textContent = ''
    }

    const updateResults = async term => {
      requestController?.abort()
      requestController = new AbortController()
      status.textContent = drawer.dataset.loadingLabel
      try {
        const url = `${window.Shopify?.routes?.root || '/'}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&section_id=printmivo-predictive-search`
        const response = await fetch(url, { signal: requestController.signal })
        if (!response.ok) throw new Error('Search request failed')
        const markup = await response.text()
        results.innerHTML = markup
        defaultContent.hidden = true
        results.hidden = false
        const count = results.querySelectorAll('.pm-search-product').length
        status.textContent = count ? (count === 1 ? drawer.dataset.resultOne : `${count} ${drawer.dataset.resultOther}`) : ''
      } catch (error) {
        if (error.name === 'AbortError') return
        window.location.href = `${searchPath}?q=${encodeURIComponent(term)}&type=product`
      }
    }

    const onInput = () => {
      const term = input.value.trim()
      clear.hidden = !term
      window.clearTimeout(requestTimer)
      if (term.length < 2) {
        showDefault()
        return
      }
      requestTimer = window.setTimeout(() => updateResults(term), 180)
    }

    document.addEventListener('click', event => {
      const searchLink = event.target.closest(`a[href="${searchPath}"], a[href="${searchPath}/"]`)
      if (searchLink) openDrawer(event)
    })
    close?.addEventListener('click', closeDrawer)
    drawer.addEventListener('click', event => {
      if (event.target === drawer) closeDrawer()
    })
    document.addEventListener('keydown', event => {
      if (!isDrawerOpen()) return
      if (event.key === 'Escape') {
        event.preventDefault()
        closeDrawer()
        return
      }
      if (event.key !== 'Tab') return
      const focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(element => !element.hidden && element.offsetParent !== null)
      if (!focusable.length) return
      const first = focusable[0]
      const last = focusable[focusable.length - 1]
      if (!drawer.contains(document.activeElement)) {
        event.preventDefault()
        ;(event.shiftKey ? last : first).focus()
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    })
    input?.addEventListener('input', onInput)
    clear?.addEventListener('click', () => {
      input.value = ''
      clear.hidden = true
      showDefault()
      input.focus()
    })
    drawer.querySelectorAll('[data-pm-search-term]').forEach(button => {
      button.addEventListener('click', () => {
        input.value = button.dataset.pmSearchTerm
        clear.hidden = false
        updateResults(input.value)
      })
    })
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["printmivo-stamp-social-proof"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('printmivo-testimonials')) {
    customElements.define('printmivo-testimonials', class extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return
        this.isInitialized = true
        this.track = this.querySelector('[data-testimonial-track]')
        this.slides = Array.from(this.querySelectorAll('[data-testimonial-slide]'))
        this.dots = Array.from(this.querySelectorAll('[data-testimonial-dot]'))
        this.currentIndex = 0
        this.interval = Number(this.dataset.interval) || 2000
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
        this.uploader = this.closest('.m-product-info--wrapper')?.querySelector('[data-stamp-upload]')
        this.onUploadStateChange = () => {
          const textFields = this.uploader?.querySelector('[data-upload-text-fields]')
          const shouldHide = Boolean(textFields && !textFields.hidden)
          this.hidden = shouldHide
          this.setAttribute('aria-hidden', shouldHide ? 'true' : 'false')
          if (shouldHide) this.stop()
          else this.start()
        }
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.show(index)
            this.restart()
          })
        })
        this.addEventListener('mouseenter', () => this.stop())
        this.addEventListener('mouseleave', () => this.start())
        this.addEventListener('focusin', () => this.stop())
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.start()
        })
        this.onVisibilityChange = () => {
          if (document.hidden) this.stop()
          else this.start()
        }
        document.addEventListener('visibilitychange', this.onVisibilityChange)
        if (this.uploader) {
          this.uploadObserver = new MutationObserver(this.onUploadStateChange)
          this.uploadObserver.observe(this.uploader, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class', 'hidden', 'aria-hidden', 'data-upload-state']
          })
        }
        this.show(0)
        this.dataset.ready = 'true'
        this.onUploadStateChange()
      }

      disconnectedCallback() {
        this.stop()
        this.uploadObserver?.disconnect()
        document.removeEventListener('visibilitychange', this.onVisibilityChange)
      }

      show(index) {
        this.currentIndex = (index + this.slides.length) % this.slides.length
        this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`
        this.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === this.currentIndex ? 'false' : 'true')
        })
        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === this.currentIndex) dot.setAttribute('aria-current', 'true')
          else dot.removeAttribute('aria-current')
        })
      }

      start() {
        if (this.hidden || this.slides.length < 2 || this.motionQuery.matches || document.hidden) return
        this.stop()
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.interval)
      }

      stop() {
        window.clearInterval(this.timer)
      }

      restart() {
        this.stop()
        this.start()
      }
    })
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["printmivo-sticker-social-proof"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('printmivo-sticker-testimonials')) {
    customElements.define('printmivo-sticker-testimonials', class extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return
        this.isInitialized = true
        this.track = this.querySelector('[data-sticker-testimonial-track]')
        this.slides = Array.from(this.querySelectorAll('[data-sticker-testimonial-slide]'))
        this.dots = Array.from(this.querySelectorAll('[data-sticker-testimonial-dot]'))
        this.currentIndex = 0
        this.interval = Number(this.dataset.interval) || 2500
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.show(index)
            this.restart()
          })
        })
        this.addEventListener('mouseenter', () => this.stop())
        this.addEventListener('mouseleave', () => this.start())
        this.addEventListener('focusin', () => this.stop())
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.start()
        })
        this.onVisibilityChange = () => {
          if (document.hidden) this.stop()
          else this.start()
        }
        document.addEventListener('visibilitychange', this.onVisibilityChange)
        this.show(0)
        this.dataset.ready = 'true'
        this.start()
      }

      disconnectedCallback() {
        this.stop()
        document.removeEventListener('visibilitychange', this.onVisibilityChange)
      }

      show(index) {
        this.currentIndex = (index + this.slides.length) % this.slides.length
        this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`
        this.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === this.currentIndex ? 'false' : 'true')
        })
        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === this.currentIndex) dot.setAttribute('aria-current', 'true')
          else dot.removeAttribute('aria-current')
        })
      }

      start() {
        if (this.slides.length < 2 || this.motionQuery.matches || document.hidden) return
        this.stop()
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.interval)
      }

      stop() {
        window.clearInterval(this.timer)
      }

      restart() {
        this.stop()
        this.start()
      }
    })
  }
  } catch(e) { console.error(e); }
})();

})();
